import React from "react";
import Grid from "@material-ui/core/Grid";
import { _Card } from "../../components";
import { _IncrementField, _StateField } from "../../form";

export class CCalculationField {
    Id: string;
    Label: string;
    Value: number;

    constructor(id: string, label: string, value: number) {
        this.Id = id;
        this.Label = label;
        this.Value = value;
    }
}

interface ICalculationCardProps {
    AcceptableLimit: number;
    FieldA: CCalculationField;
    FieldB: CCalculationField;
    GoodLimit: number;
    Id: string;
    LowLimit: number;
    Title: string;
    OnChange: (e: string, val: string) => void;
    ReverseDirection?: boolean;
}

export const _CalculationCard: React.FC<ICalculationCardProps> = ({ FieldA, FieldB, Id, Title, OnChange, AcceptableLimit, LowLimit, GoodLimit, ReverseDirection }) => {
    const val = FieldB.Value != 0 ? FieldA.Value / FieldB.Value : 0;

    return (
        <_Card Title={Title}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <_IncrementField Id={FieldA.Id} Label={FieldA.Label} Value={FieldA.Value} OnChange={OnChange} />
                </Grid>
                <Grid item xs={12}>
                    <_IncrementField Id={FieldB.Id} Label={FieldB.Label} Value={FieldB.Value} OnChange={OnChange} />
                </Grid>
                <Grid item xs={12}>
                    <_StateField
                        Id={Id}
                        Label="Valutazione"
                        Value={val}
                        OnChange={() => {}}
                        AcceptableLimit={AcceptableLimit}
                        GoodLimit={GoodLimit}
                        LowLimit={LowLimit}
                        ReverseDirection={ReverseDirection}
                    />
                </Grid>
            </Grid>
        </_Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsAssessment/CalculationCard.tsx